import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import AISummary from "../../components/modules/ai-summary/AISummary";

export default class AISummaryRepository extends BaseRepository {
  static modelClass = AISummary;
  modelName = "ai-summary";
}
